import React from 'react';
import classNames from 'classnames';
import { useProgressStepper } from './ProgressStepperContext';
import { useStep } from './StepContext';

const StepNonLinearConnector = () => {

  const { isVertical } = useProgressStepper();
  const { index, last } = useStep();
  const first = index === 0;

  const horizontalClasses = classNames(
    'sui-absolute sui-top-[23px] sui-w-full sui-h-2px sui-bg-strong',
    {
      'sui-rounded-l-md': first,
      'sui-rounded-r-md': last
    }
  );
  const verticalClasses = classNames(
    'sui-absolute sui-left-[15px] sui-w-2px sui-bg-strong sui-top-5',
    {
      'sui-h-full': !last,
      'sui-h-0': last,
    }
  );
  const classes = isVertical ? verticalClasses : horizontalClasses;

  return <div className={classes} />;
};

StepNonLinearConnector.displayName = 'StepNonLinearConnector';

StepNonLinearConnector.propTypes = {
};

export { StepNonLinearConnector };